<template>
  <section>
    <bannertitle link_href="/about">
      <template slot="tag">隐私政策</template>
      <template slot="title">隐私政策</template>
      <template slot="subtitle"></template>
    </bannertitle>
    <section class="banner_image">
      <div class="width_100">
        <picture class="width_100">
          <img src="@/assets/FFP/images/privacypolicy-banner.png"
               alt="privacypolicy-banner.png"
               class="width_100">
        </picture>
      </div>
    </section>
    <section class="about_company">
      <div class="content_container">
        <div class="paragraph">&nbsp;</div>
        <div class="paragraph">更新日期：2024年9月1日</div>
        <div class="paragraph">生效日期：2024年9月1日</div>
        <div class="paragraph font_bold3">提示条款</div>
        <div class="paragraph">佳能商务科技（广东）有限公司（以下简称“佳能商务科技（广东）”或“我们”）非常重视用户的隐私和个人信息保护。您在使用我们的相关服务时，我们可能会处理您的相关信息。我们希望通过本《隐私政策》（以下简称“本政策”）向您说明，在使用我们的服务时，收集您的哪些个人信息，我们如何处理这些信息，以及我们为您提供的行使您的信息权利的方式。</div>
        <div class="paragraph"><span2>本政策与我们提供的服务和您的权益息息相关，希望您仔细阅读并透彻理解本政策，特别应重点阅读我们以粗体或粗体下划线标识的条款。在需要时，按照本政策的指引，作出您认为适当的选择。</span2>本政策中涉及的相关技术词汇，我们尽量以简明扼要的表述向您解释，以便您的理解。 <span2>一旦您使用我们的服务，即意味着您已充分理解并同意我们按照本政策处理您的相关信息。当我们更新本政策后，您继续使用我们的服务，即意味着您已充分理解并同意本政策的更新。</span2></div>
        <div class="paragraph"><span2>本政策适用于本网站及佳能商务科技（广东）所有、参与或组织的客户端、小程序、线下活动等渠道所提供的产品或服务。</span2></div>
        <div class="paragraph font_bold3">隐私政策条款</div>
        <div class="paragraph font_bold2">本政策将帮助您了解以下内容：</div>
        <div class="paragraph">一. &nbsp;&nbsp;我们如何收集和使用您的个人信息</div>
        <div class="paragraph">二. &nbsp;&nbsp;我们如何使用 Cookie 和同类技术</div>
        <div class="paragraph">三. &nbsp;&nbsp;我们如何委托其他方处理、向其他个人信息处理者提供、转移和公开披露您的个人信息</div>
        <div class="paragraph">四. &nbsp;&nbsp;我们如何保护您的个人信息</div>
        <div class="paragraph">五. &nbsp;&nbsp;您的权利</div>
        <div class="paragraph">六. &nbsp;&nbsp;我们如何处理未成年人的个人信息</div>
        <div class="paragraph">七. &nbsp;&nbsp;您的个人信息如何储存以及如何在全球范围转移</div>
        <div class="paragraph">八. &nbsp;&nbsp;本政策如何更新</div>
        <div class="paragraph">九. &nbsp;&nbsp;如何联系我们</div>
        <div class="paragraph">十. &nbsp;&nbsp;术语解释</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">一、我们如何收集和使用您的个人信息</div>
        <div class="paragraph">我们仅在具有特定的目的和充分的必要性，并且采取了严格的保护措施的情形下，才会处理您的敏感个人信息。在本政策中，我们对涉及的敏感个人信息以<span>粗体</span>进行显著标识。</div>
        <div class="paragraph"></div>
        <div class="paragraph"><span2>因我们向您提供的产品或服务的种类众多，且不同的用户授权我们处理的个人信息的类型、范围等会有所区别，请以具体的产品/服务的功能为准。</span2></div>
        <div class="paragraph"></div>
        <div class="paragraph"><span2>请您注意，如果您在使用我们的相关产品/服务时提供的是他人的信息，请您确保已经取得相关个人的授权同意。</span2></div>
        <div class="paragraph"></div>
        <div class="paragraph">我们仅会出于本政策所述的以下目的，收集和使用您的个人信息：</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">（一）为您所在机构购买、使用佳能产品/服务提供服务和支持或进行商业合作</div>
        <div class="paragraph">我们会为您所在的机构购买、使用佳能产品/服务提供服务和支持或与您所在的机构进行商业合作，进行相关财务管理、销售管理活动，如您代表您所在的机构使用我们的产品、参与我们举办的培训、会议等活动、接受我们提供的服务或代表您所在的机构与我们进行商业合作，我们可能会收集您的姓名、电话、电邮、职务等个人信息，以明确您的身份。</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">（二）向您展示或提供商品和服务信息</div>
        <div class="paragraph">为向您展示或提供商品和服务信息，我们可能会根据您提供的信息和您使用我们的产品/服务的过程中产生的信息，如您的设备信息、IP地址、您的浏览记录等，提取您的搜索偏好、所在区域、行为习惯等特征，进行间接人群画像、向您提供更契合您需求的展示和搜索结果或展示、推送您感兴趣的商品或服务信息。</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">（三）为您参与我们的市场推广活动提供服务和支持</div>
        <div class="paragraph">当您参加我们组织的市场推广活动时，我们可能需要获取您的称谓、姓名、电话、电邮、职务、公司名称等个人信息及其他您同意并提供的信息以进行报名、签到、抽取礼品等活动。</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">（四）向您提供与佳能产品或者服务相关的信息</div>
        <div class="paragraph">在已获得您事先的书面同意下，我们可能通过您提供的联系方式，如您的姓名、电话、电邮、职务等个人信息，向您提供与佳能产品或者服务相关的信息（包括但不限于佳能产品的宣传资料、调查问卷以及促销活动信息），展示、推送您感兴趣的产品或服务信息。</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">（五）征询您的意见</div>
        <div class="paragraph">我们可能通过您提供的联系方式，回复及解决您所提出的疑问或要求，邀请您参与市场调查，以衡量您对我们的产品、服务和网站的兴趣，或者向您发送问卷调查或邀请您对我们的服务提供反馈等。<span2>根据调查内容的不同，我们可能会需要您提供不同类型的个人信息。如果您不希望提供前述个人信息，您可以拒绝提供反馈或填写调查问卷。</span2></div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">（六）供应商合作</div>
        <div class="paragraph">如您所在的机构是我们的供应商，您代表您所在的机构与我们进行商业合作，我们可能会收集您的姓名、电话、电邮等个人信息，以保持与您和您所在的机构的联系、处理合作款项。</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">（七）内部审计、数据统计、分析和研究</div>
        <div class="paragraph">我们可能会为了内部审计、数据统计、分析和研究以及衡量广告活动的有效性，而收集您的IP地址、浏览记录等，改善我们向您提供的产品/服务。</div>
        <div class="paragraph"></div>
        <div class="paragraph"><span2>我们可能会将我们基于本网站所获得的您的个人信息与我们在其他由佳能举办的活动或提供的服务等中所收集的您的个人信息、我们的关联公司或合作伙伴与我们共享的信息结合起来，进行数据分析，以便我们为您提供更加个性化的内容和服务。</span2></div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">（八）为您提供安全保障</div>
        <div class="paragraph">为保障您使用我们的产品、服务或本网站等平台时的安全性，保护您、其他用户或公众的人身财产安全，我们可能会收集、使用或整合您的注册信息、设备信息、IP地址、日志信息等、您授权我们的关联公司或合作伙伴共享的信息来进行风险评估、身份验证，检测和预防安全事件，维护网络安全或排除网络故障，依法采取必要的记录、审计、分析或处置措施。</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">（九）征得授权同意的例外</div>
        <div class="paragraph"><span1>根据相关法律法规的规定，以下情形中我们处理您的个人信息无需征得您的授权同意：</span1></div>
        <div class="paragraph">1、为订立、履行您与我们之间的合同所必需；</div>
        <div class="paragraph">2、为履行法定职责或者法定义务所必需；</div>
        <div class="paragraph">3、为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</div>
        <div class="paragraph">4、为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</div>
        <div class="paragraph">5、依照《个人信息保护法》规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；或</div>
        <div class="paragraph">6、法律行政法规、国家标准规定的其他情形。</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">二、我们如何使用 Cookie和同类技术</div>
        <div class="paragraph font_bold2">（一）Cookie</div>
        <div class="paragraph">在您访问我们的网页时，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。借助于 Cookie，网站能够存储您的偏好等数据。</div>
        <div class="paragraph"></div>
        <div class="paragraph">我们不会将Cookie用于本政策所述目的之外的任何目的。您可根据自己的偏好管理或删除 Cookie。有关详情，请参见AboutCookies.org。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">（二）其他同类技术</div>
        <div class="paragraph">除 Cookie 外，我们还会在网站上使用网站信标、像素标签等其他同类技术，帮助我们了解您的产品或服务偏好并改善客户服务。</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">三、我们如何委托其他方处理、向其他个人信息处理者提供、转移和公开披露您的个人信息</div>
        <div class="paragraph font_bold2">（一）委托其他方处理您的个人信息</div>
        <div class="paragraph">为了提供您所要求的服务，我们有时会在合法、必要、正当、特定、目的明确的条件下，委托第三方服务供应商提供相关服务并处理您的个人信息，以实现本政策所述功能。我们委托服务供应商处理您个人信息的情况包括以下几类：</div>
        <div class="paragraph">（1）广告、分析服务类授权合作伙伴；</div>
        <div class="paragraph">（2）供应商、服务提供商和其他合作伙伴。包括但不限于IT类服务供应商、客户服务类供应商、线上平台运营类服务供应商等。</div>
        <div class="paragraph"><span2>我们在委托这些服务供应商处理您的个人信息前，会按照法律规定进行相关评估，并与这些服务供应商签订相关的保密及个人信息保护条款，要求这些服务供应商采取相应的保护措施，严格遵守相关法律法规的要求，对您的个人信息进行有效保护。</span2></div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">（二）向其他个人信息处理者提供您的个人信息</div>
        <div class="paragraph">当我们向其他个人信息处理者提供您的个人信息时，我们将向您告知接收方的名称或者姓名、联系方式、处理目的、处理方式和个人信息的种类。如我们是基于您的同意而提供您的个人信息的，我们还会根据相关法律法规的要求取得您的单独同意。我们向其他个人信息处理者提供您的个人信息的情况包括：</div>
        <div class="paragraph"><span2>我们可能会根据法律法规规定、诉讼争议需要、事前明示的活动规则或合同或按行政、司法机关依法提出的要求向其提供您的个人信息。</span2></div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">（三）转移</div>
        <div class="paragraph">我们不会将您的个人信息转移给任何公司、组织和个人，但以下情况除外：</div>
        <div class="paragraph">1、事先获得您明确的同意或收到您主动请求的；</div>
        <div class="paragraph">2、在涉及合并、分立、收购、解散或破产清算等情形时，如涉及到个人信息转移，我们将向您告知接收方的名称或者姓名和联系方式。接收方应当继续履行本政策以及相关法律法规下的个人信息处理者的义务。接收方变更原先的处理目的、处理方式的，应当依照相关法律法规重新取得您的同意。</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">（四）公开披露</div>
        <div class="paragraph">我们不会公开披露您的个人信息，除非：</div>
        <div class="paragraph">1、事先获得您的单独同意；</div>
        <div class="paragraph">2、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">四、我们如何保护您的个人信息</div>
        <div class="paragraph">我们会按照法律法规的规定，尽到个人信息处理者的义务，采取相应的措施确保我们的个人信息处理活动符合法律、行政法规的规定，防止未经授权的访问以及个人信息泄露、篡改、丢失。</div>
        <div class="paragraph"></div>
        <div class="paragraph">互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件等与其他用户的交流方式无法确定是否完全加密，我们建议您使用此类工具时请使用复杂密码，妥善保护自己的个人信息，仅在必要的情形下谨慎发送、共享个人信息。请使用复杂密码，协助我们保证您的账号安全。</div>
        <div class="paragraph"></div>
        <div class="paragraph">请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。</div>
        <div class="paragraph"></div>
        <div class="paragraph">当发生或者可能发生个人信息泄露、篡改、丢失时，我们将根据相关法律法规要求立即采取补救措施，并向您及相关履行个人信息保护职责的部门进行通知。通知的内容包括：</div>
        <div class="paragraph">（1）发生或者可能发生个人信息泄露、篡改、丢失的信息种类、原因和可能造成的危害；</div>
        <div class="paragraph">（2）我们采取的补救措施和您可以采取的减轻危害的措施；和</div>
        <div class="paragraph">（3）我们的联系方式。</div>
        <div class="paragraph"></div>
        <div class="paragraph">我们将以邮件、信函、电话、推送通知等方式向您进行上述通知，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。如果我们采取措施能够有效避免信息泄露、篡改、丢失造成危害的，我们将不会向您进行通知（相关履行个人信息保护职责的部门另有要求的除外）。</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">五、您的权利</div>
        <div class="paragraph">按照中国相关的法律、法规、标准，我们保障您对自己的个人信息行使以下权利：</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">（一）查询、更正您的个人信息</div>
        <div class="paragraph">您有权查阅、更正您的个人信息，如您需要查询和更正我们处理的您的个人信息，您可以通过本政策“如何联系我们”部分列明的联系方式联系我们，我们会根据本政策所列明的方式和期限响应您的请求。</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">（二）删除您的个人信息</div>
        <div class="paragraph">在出现下列情形时，我们将根据相关法律法规及时主动删除您的个人信息。如果我们未能删除，您可以通过本政策“如何联系我们”部分列明的联系方式联系我们，向我们提出删除个人信息的请求：</div>
        <div class="paragraph">（1）处理目的已实现、无法实现或者为实现处理目的不再必要；</div>
        <div class="paragraph">（2）我们停止提供产品或者服务，或者保存期限已届满；</div>
        <div class="paragraph">（3）您已撤回同意；</div>
        <div class="paragraph">（4）我们违反法律、行政法规或者违反约定处理个人信息；</div>
        <div class="paragraph">（5）法律、行政法规规定的其他情形。</div>
        <div class="paragraph"></div>
        <div class="paragraph">若我们决定响应您的删除请求，我们会根据适用法律法规的要求删除您的个人信息或进行匿名化处理。</div>
        <div class="paragraph">我们还将尽可能通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。</div>
        <div class="paragraph"></div>
        <div class="paragraph">因为适用的法律和安全技术限制，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直到备份可以清除或实现匿名。</div>
        <div class="paragraph"></div>
        <div class="paragraph">法律法规规定的保存期限未届满，或者删除个人信息从技术上难以实现的，我们将停止除存储和采取必要的安全保护措施之外的处理。</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">（三）改变您授权同意的范围</div>
        <div class="paragraph">对于我们基于您的同意所收集的您的个人信息，您可以随时给予或撤回您的授权同意。<span2>您可以自行通过关闭设备功能等方式变更您授权我们继续收集您个人信息的范围或撤回您的授权，您也可以通过本政策“如何联系我们”部分所列的联系方式联系我们，描述您改变授权同意的需求。</span2></div>
        <div class="paragraph"></div>
        <div class="paragraph"><span>请注意，我们的产品/服务需要一些基本的个人信息才能得以完成（见本政策“一、我们如何收集和使用您的个人信息”）。当您删除个人信息、改变授权同意的范围后，我们可能无法继续为您提供必需相关个人信息才能提供的服务。您删除个人信息、改变授权同意的范围的决定，不会影响我们此前基于您的同意或其他合法事由而对您个人信息的处理行为。</span></div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">（四）复制您的个人信息</div>
        <div class="paragraph">您有权获取您的个人信息副本。如您需要获取我们收集的您的个人信息副本，您可以通过本政策“如何联系我们”部分所列的联系方式联系我们。在符合相关法律规定且技术可行的前提下，我们将根据您的要求向您提供您的个人信息副本。</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">（五）约束自动化决策</div>
        <div class="paragraph">在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制作出决定。我们将保证决策的透明度和结果公平、公正，不会对您在交易价格等交易条件上实行不合理的差别待遇。如果我们通过自动化决策方式向您进行信息推送、商业营销，我们将向您提供便捷的拒绝方式，<span2>您可以通过本政策“如何联系我们”部分所列的联系方式联系我们行使您拒绝自动化决策的权利。</span2></div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">（六）响应您的上述请求</div>
        <div class="paragraph">为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。我们将在15个工作日内作出答复。</div>
        <div class="paragraph"></div>
        <div class="paragraph">对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</div>
        <div class="paragraph"></div>
        <div class="paragraph">在以下情形中，按照法律法规要求，我们将无法响应您的请求：</div>
        <div class="paragraph">1、 与我们履行法律法规规定的义务相关的；</div>
        <div class="paragraph">2、 与国家安全、国防安全有关的；</div>
        <div class="paragraph">3、 与公共安全、公共卫生、重大公共利益有关的；</div>
        <div class="paragraph">4、 与犯罪侦查、起诉、审判和判决执行等有关的；</div>
        <div class="paragraph">5、 有充分证据表明您存在主观恶意或滥用权利的；出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</div>
        <div class="paragraph">6、 响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</div>
        <div class="paragraph">7、 涉及商业秘密的。</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">六、我们如何处理未成年人的个人信息</div>
        <div class="paragraph"><span2>在您使用我们的产品/服务或向我们提供您的个人信息时，我们推定您具有相应的民事行为能力。</span2></div>
        <div class="paragraph"></div>
        <div class="paragraph">我们非常重视未成年人个人信息的保护。<span2>如果您是18周岁以下的未成年人，在您使用我们的产品/服务前，您和您的监护人应仔细阅读并理解本政策，且您应在监护人明确同意和指导下使用我们的产品/服务或向我们提交个人信息。</span2></div>
        <div class="paragraph"></div>
        <div class="paragraph"><span2>如果您是14周岁以下儿童，在您使用我们的产品/服务前，您和您的监护人应仔细阅读我们专门制定的《儿童个人信息保护规则》，确保在取得监护人对《儿童个人信息保护规则》的同意后，在监护人的同意和指导下使用我们的产品/服务或向我们提交个人信息。</span2></div>
        <div class="paragraph"></div>
        <div class="paragraph"><span2>若您是18周岁以下未成年人的监护人，请您关注您的未成年人是否在取得您的授权同意之后使用我们的服务。</span2>若您对您所监护的未成年人的个人信息有疑问的，请与我们联系。如果有事实证明未成年人在未取得其父母或其他监护人同意的情况下注册使用了我们的服务，我们会与相关监护人协商，并设法尽快删除相关个人信息。</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">七、您的个人信息如何储存以及如何在全球范围转移</div>
        <div class="paragraph font_bold2">（一）您的个人信息如何储存</div>
        <div class="paragraph">我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律法规有强制的留存要求。我们判断个人信息的存储期限主要参考以下标准并以其中较长者为准：</div>
        <div class="paragraph">（1）为订立和履行合同所必需、完成与您相关的交易目的、维护相应交易及业务记录，以应对您可能的查询或投诉；</div>
        <div class="paragraph">（2）保证我们为您提供服务的安全和质量；</div>
        <div class="paragraph">（3）您是否同意更长的留存期间；</div>
        <div class="paragraph">（4）是否存在关于保留期限的其他特别约定或法律法规规定。</div>
        <div class="paragraph"></div>
        <div class="paragraph">在超出保留期间后，我们会根据适用法律法规的要求删除您的个人信息或进行匿名化处理。法律法规规定的保存期限未届满，或者删除个人信息从技术上难以实现的，我们将停止除存储和采取必要的安全保护措施之外的处理。</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">（二）您的个人信息如何在全球范围转移</div>
        <div class="paragraph">对于我们在中华人民共和国境内收集和产生的个人信息，原则上我们将存储在中华人民共和国境内。如果在特定情况下，比如需要境外的公司为您提供售后或其他行政服务、为了订立和履行的合同所必需、为提供服务或解决产品质量问题、分析和提高产品质量，我们需要将您的相关信息传输到境外的公司，包括但不限于位于中国内地境外的佳能关联公司、分包商及/或第三方服务供应商，我们将向您告知境外接收方的名称或者姓名、联系方式、处理目的、处理方式、个人信息的种类以及个人可以如何行使权利，并在适用法律要求的情况下征求您的单独同意。</div>
        <div class="paragraph"></div>
        <div class="paragraph">我们将按照法律法规要求采取必要措施，与境外接收方订立合同，保障境外接收方处理个人信息的活动达到相关法律法规要求的个人信息保护标准。</div>
        <div class="paragraph"></div>
        <div class="paragraph">目前我们会在以下场景中将您的个人信息提供给境外接收方：</div>
        <div class="paragraph">1、供应商合作</div>
        <div class="paragraph">个人信息主体：与我们合作的供应商代表、联系人</div>
        <div class="paragraph">境外接收方：佳能香港有限公司</div>
        <div class="paragraph">联系方式：privacy_officer@chk.canon.com.hk</div>
        <div class="paragraph">个人信息的种类：姓名、电话号码、电子邮件地址</div>
        <div class="paragraph">处理目的：协助我们与供应商进行联络沟通，处理相关款项，提供系统支持</div>
        <div class="paragraph">处理方式：收集、存储、使用、传输、删除</div>
        <div class="paragraph">向境外其他接收方提供：根据公司全球性业务及信息系统安排，佳能香港有限公司可能需要使用佳能新加坡有限公司（Canon Singapore Pte. Ltd.，新加坡加拉克斯区14-10号富西诺波利斯1号）管理的信息系统处理上述个人信息，佳能新加坡有限公司对个人信息的处理目的以及处理方式与佳能香港有限公司一致，并按本政策所述期限对信息进行保存。</div>
        <div class="paragraph"></div>
        <div class="paragraph">2、财务管理</div>
        <div class="paragraph">个人信息主体：通过我们购买、使用佳能产品/服务、进行商业合作的机构客户代表、联系人</div>
        <div class="paragraph">境外接收方：佳能香港有限公司</div>
        <div class="paragraph">联系方式：privacy_officer@chk.canon.com.hk</div>
        <div class="paragraph">处理目的：协助我们管理和发送账单，与客户联系沟通，提供系统支持</div>
        <div class="paragraph">个人信息的种类：姓名、电话号码、电子邮件地址</div>
        <div class="paragraph">处理方式：收集、存储、使用、传输、删除</div>
        <div class="paragraph"></div>
        <div class="paragraph">3、活动管理</div>
        <div class="paragraph">个人信息主体：通过我们购买、使用佳能产品/服务、进行商业合作的机构客户代表、联系人</div>
        <div class="paragraph">境外接收方：佳能香港有限公司</div>
        <div class="paragraph">联系方式：privacy_officer@chk.canon.com.hk</div>
        <div class="paragraph">个人信息的种类：客户联系人的称谓、姓名、电话号码、电子邮件地址、就职公司名称、职位</div>
        <div class="paragraph">处理目的：协助我们记录报名参加公司组织的宣传活动的人员信息，确认活动参加者资格，提供系统支持</div>
        <div class="paragraph">处理方式：收集、存储、使用、传输、删除</div>
        <div class="paragraph"></div>
        <div class="paragraph">4、销售管理</div>
        <div class="paragraph">个人信息主体：通过我们购买、使用佳能产品/服务、进行商业合作的机构客户代表、联系人</div>
        <div class="paragraph">境外接收方：佳能香港有限公司</div>
        <div class="paragraph">联系方式：privacy_officer@chk.canon.com.hk</div>
        <div class="paragraph">个人信息的种类：姓名、电话号码、电子邮件地址</div>
        <div class="paragraph">处理目的：协助我们安排采购送货并进行合同管理，提供系统支持</div>
        <div class="paragraph">处理方式：收集、存储、使用、传输、删除</div>
        <div class="paragraph"></div>
        <div class="paragraph">您可以通过上述境外接收方的联系方式联系境外接收方（包括其他后续接收方）以行使查阅、复制、更正、补充、删除、拒绝处理、撤回同意等个人信息主体权利，您也可以通过本政策“九、如何联系我们”所述的联系方式与我们联系，我们将协助您处理。</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">八、本政策如何更新</div>
        <div class="paragraph">为给您提供更好的服务以及随着我们业务的发展，本政策也会随之适时变更。但未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会通过在本网站上发出更新版本并在生效前通过网站公告或以其他适当方式提醒您相关内容的更新，也请您访问本网站及时了解最新的隐私政策。对于重大变更，我们会提供更为显著的通知（包括网站以推送通知、弹窗的形式向您展示）。</div>
        <div class="paragraph"></div>
        <div class="paragraph">本政策所指的重大变更包括但不限于：</div>
        <div class="paragraph">（1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</div>
        <div class="paragraph">（2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</div>
        <div class="paragraph">（3）个人信息对外提供的主要对象发生变化；</div>
        <div class="paragraph">（4）您参与个人信息处理方面的权利及其行使方式发生重大变化；</div>
        <div class="paragraph">（5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</div>
        <div class="paragraph">（6）个人信息安全影响评估报告表明存在高风险时。</div>
        <div class="paragraph"></div>
        <div class="paragraph">如您在本政策更新生效后继续使用我们的服务，即代表您已充分阅读、理解并接受更新后的政策并愿意受更新后的政策约束。</div>
        <div class="paragraph"></div>
        <div class="paragraph">我们还会将本政策的旧版本存档，您可以通过发送邮件至【cbsg_privacy@cbsg.canon.com.cn】申请查阅。</div>
        <div class="paragraph"></div>
        <div class="paragrap font_bold2">九、如何联系我们</div>
        <div class="paragraph">如果您对本政策有任何疑问、意见或建议，或者您在处理您的个人信息时遇到任何问题，请<a href="mailto:cbsg_privacy@cbsg.canon.com.cn">点击此处</a>与我们联系。一般情况下，我们将在十五个工作日内回复。</div>
        <div class="paragraph"></div>
        <div class="paragraph">如果您对我们的回复不满意，或者认为我们的个人信息处理行为损害了您的合法权益，您还可以通过以下外部途径寻求解决方案：向深圳市福田区人民法院提起诉讼，或向有关部门反映。</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">十、术语解释</div>
        <div class="paragraph"><span>个人信息</span>：指以个人信息是以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。</div>
        <div class="paragraph"><span>敏感个人信息</span>：是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。</div>
        <div class="paragraph"><span>儿童</span>：不满十四周岁未成年人的个人信息。</div>
        <div class="paragraph"><span>处理</span>：包括个人信息的收集、存储、使用、加工、传输、提供、公开、删除等。</div>
        <div class="paragraph"><span>个人信息处理者</span>：在个人信息处理活动中自主决定处理目的、处理方式的组织、个人。</div>
        <div class="paragraph"><span>自动化决策</span>：通过计算机程序自动分析、评估个人的行为习惯、兴趣爱好或者经济、健康、信用状况等，并进行决策的活动。</div>
        <div class="paragraph"><span>去标识化</span>：指个人信息经过处理，使其在不借助额外信息的情况下无法识别特定自然人的过程。</div>
        <div class="paragraph"><span>匿名化</span>：指个人信息经过处理无法识别特定自然人且不能复原的过程。</div>
        <div class="paragraph"></div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold3">佳能儿童个人信息保护规则</div>
        <div class="paragraph">更新日期：2024年9月1日</div>
        <div class="paragraph">生效日期：2024年9月1日</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold3">提示条款</div>
        <div class="paragraph"></div>
        <div class="paragraph">佳能商务科技（广东）有限公司（以下简称“佳能商务科技（广东）”或“我们”）深知儿童（指未满十四周岁的未成年人）个人信息和隐私安全的重要性。为保障儿童个人信息及隐私安全，我们在《佳能隐私政策》的基础之上，专门制定了《佳能儿童个人信息保护规则》（以下简称“本规则”）。我们希望通过本规则向您说明，我们在收集和使用儿童个人信息时对应的处理规则等相关事宜。</div>
        <div class="paragraph"></div>
        <div class="paragraph"><span2>请您知悉并理解，本规则仅适用于我们专门面向儿童提供的产品/服务，或者我们根据用户输入的生日、年龄等信息能主动识别用户为儿童的产品/服务，针对不能识别或不主动识别用户年龄的产品或服务，仅适用《佳能隐私政策》和具体产品/服务的隐私政策（如有）。</span2></div>
        <div class="paragraph"></div>
        <div class="paragraph">在适用本规则的情况下，如本规则与《佳能隐私政策》和具体产品/服务的隐私政策（如有）的条款规定存在不一致的，以本规则为准；本规则未载明之处，请参照《佳能隐私政策》或具体产品/服务的隐私政策（如有）。</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">监护人特别说明：</div>
        <div class="paragraph">如果您是儿童用户的监护人，请您务必仔细阅读并透彻理解本规则，在确认充分理解并同意本规则的全部条款后再允许您的孩子使用我们提供的产品/服务。为了与您共同保护儿童的个人信息，我们希望您可以协助我们，确保您的孩子在您的同意和指导下使用我们的产品/服务或向我们提交个人信息。<span2>如果您不同意本规则的内容，请您要求您的孩子立即停止访问与使用我们的产品/服务。但这可能会导致您的孩子无法正常使用部分产品/服务，但不影响您的孩子使用我们提供的其他产品/服务。</span2></div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">儿童特别说明：</div>
        <div class="paragraph">如果你是14周岁以下的未成年人，你需要和你的监护人一起仔细阅读本规则，并在征得你的监护人同意后，使用我们的产品、服务或向我们提供你的个人信息。</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold3">儿童个人信息保护规则条款</div>
        <div class="paragraph font_bold2">本规则将帮助您了解以下内容：</div>
        <div class="paragraph">1、我们如何收集和使用儿童个人信息</div>
        <div class="paragraph">2、我们如何委托其他方处理、向其他个人信息处理者提供、转移和公开披露儿童个人信息</div>
        <div class="paragraph">3、我们如何保护儿童个人信息</div>
        <div class="paragraph">4、我们如何存储儿童个人信息</div>
        <div class="paragraph">5、如何管理儿童个人信息</div>
        <div class="paragraph">6、本规则如何更新</div>
        <div class="paragraph">7、如何联系我们</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">一、我们如何收集和使用儿童个人信息</div>
        <div class="paragraph">我们会严格履行法律法规规定的儿童个人信息保护义务与责任，遵循正当必要、知情同意、目的明确、安全保障、依法利用的原则，在征得监护人的同意后收集和使用儿童个人信息。您在使用我们的产品/服务中主动向我们提供您孩子的个人信息，例如您在大影家平台上上传的作品图片/视频包含了您孩子的照片、视频或其他信息，或是在我们举行的线下活动中向我们提供您孩子的个人信息，即表示您已经同意我们收集和按照本规则的内容使用您孩子的个人信息。</div>
        <div class="paragraph"></div>
        <div class="paragraph">您或您的孩子在使用我们的产品/服务过程中，我们可能还会收集和使用其他儿童个人信息，有关具体的使用目的、收集个人信息的范围以及拒绝提供相应信息的后果请您查阅《佳能隐私政策》“我们如何收集和使用您的个人信息”章节进行详细了解。</div>
        <div class="paragraph"></div>
        <div class="paragraph">此外，我们也会通过Cookies等同类技术自动收集您或您孩子的个人信息，具体请您查阅《佳能隐私政策》“我们如何使用Cookie和同类技术”部分进行详细了解。如我们需要超出上述目的和范围使用儿童个人信息，我们将再次征得监护人的同意。</div>
        <div class="paragraph"></div>
        <div class="paragraph"><span2>请您注意，绝大多数情形下我们无法识别且不会判断收集和处理的个人信息是否属于儿童个人信息，这种情形下我们将按照《佳能隐私政策》收集和处理用户的个人信息。</span2></div>
        <div class="paragraph"></div>
        <div class="paragraph">根据相关法律法规的规定，在特定情形下，我们收集儿童个人信息时无需征得儿童监护人的授权同意，具体请您查阅《佳能隐私政策》“我们如何收集和使用您的个人信息”部分进行详细了解。</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">二、我们如何委托其他方处理、向其他个人信息处理者提供、转移和公开披露儿童个人信息</div>
        <div class="paragraph">我们承诺对儿童个人信息进行严格保密，仅在您明确授权同意和本规则说明下述情况下对外共享儿童个人信息：</div>
        <div class="paragraph">1、向监护人提供。监护人可以访问和管理被监护儿童的个人信息。</div>
        <div class="paragraph">2、《佳能隐私政策》“我们如何委托其他方处理、向其他个人信息处理者提供、转移和公开披露您的个人信息”章节描述的相关情形。</div>
        <div class="paragraph">3、基于《佳能隐私政策》和本规则所述目的，我们可能委托服务供应商代表我们来处理儿童信息。我们会对受托方及委托行为等进行安全评估，在书面委托协议中明确双方责任、处理事项、处理期限、处理性质和目的等，禁止受托方超出授权范围使用儿童个人信息，并要求受托方依法履行以下义务：</div>
        <div class="paragraph">（1）按照法律、行政法规的规定和我们的要求处理儿童信息；</div>
        <div class="paragraph">（2）协助我们回应儿童监护人提出的申请；</div>
        <div class="paragraph">（3）采取措施保障信息安全，并在发生儿童信息泄露安全事件时，及时向我们反馈；</div>
        <div class="paragraph">（4）委托关系解除时及时删除儿童信息；</div>
        <div class="paragraph">（5）不得转委托；</div>
        <div class="paragraph">（6）其他依法应当履行的儿童信息保护义务。</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">三、我们如何保护儿童个人信息</div>
        <div class="paragraph">我们非常重视儿童的个人信息安全，并采取一切合理可行的措施，保护儿童个人信息：</div>
        <div class="paragraph"></div>
        <div class="paragraph">我们会遵循正当必要、知情同意、目的明确、安全保障、依法利用的原则。我们仅收集与我们提供的产品/服务相关的儿童个人信息。</div>
        <div class="paragraph"></div>
        <div class="paragraph">当我们发现儿童个人信息发生或者可能发生泄露、毁损、丢失的，我们会按照法律法规的要求，启动应急预案、采取补救措施，及时向有关主管部门报告，并将事件相关情况以邮件、信函、电话、推送通知等方式告知受影响的儿童及其监护人，难以逐一告知的，我们会采取合理、有效的方式发布相关警示信息。</div>
        <div class="paragraph"></div>
        <div class="paragraph">如您希望了解更多，请查阅《佳能隐私政策》“我们如何保护您的个人信息”章节。</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">四、我们如何存储儿童个人信息</div>
        <div class="paragraph">对于我们在中华人民共和国境内收集和产生的儿童个人信息，原则上我们将存储在中华人民共和国境内。我们存储儿童信息不会超过实现信息收集、使用目的所必需的期限，到期后我们会对儿童个人信息进行删除或匿名化处理。请查阅《佳能隐私政策》“您的个人信息如何储存以及如何在全球范围转移”章节，详细了解我们如何存储儿童个人信息。</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">五、如何管理儿童个人信息</div>
        <div class="paragraph">为了方便您和您的孩子在使用我们的产品/服务期间可以更加便捷地访问和管理儿童个人信息，同时保障撤回同意和注销账户的权利，您和您的孩子可以按照《佳能隐私政策》中“您的权利”章节的指引进行操作。</div>
        <div class="paragraph"></div>
        <div class="paragraph">下列情形下，您或您的孩子可联系我们要求删除相应的儿童信息：</div>
        <div class="paragraph">（1）我们违反法律、行政法规的规定或者双方的约定收集、存储、使用、转移、披露儿童个人信息的；</div>
        <div class="paragraph">（2）超出目的范围或者必要期限收集、存储、使用、转移、披露儿童信息的；</div>
        <div class="paragraph">（3）儿童监护人撤回同意的；</div>
        <div class="paragraph">（4）儿童或者其监护人通过注销等方式终止使用产品或者服务的。</div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">六、本规则如何更新</div>
        <div class="paragraph">为给您和您的孩子提供更好的服务以及随着我们业务的发展，本规则也会随之适时变更。但未经您和您的孩子明确同意，我们不会削减您和您的孩子依据本规则所应享有的权利。</div>
        <div class="paragraph"></div>
        <div class="paragraph"><span2>我们会通过在我们网站、移动端上发出更新版本或以其他方式提醒您和您的孩子相关内容的更新，也请您陪同和指导您的孩子访问我们以便及时了解最新的隐私政策。在前述情况下，若您和您的孩子继续使用我们的服务，即表示同意接受修订后的本规则并受之约束。</span2></div>
        <div class="paragraph"></div>
        <div class="paragraph font_bold2">七、如何联系我们</div>
        <div class="paragraph">如果您和您的孩子对本规则有任何疑问、意见或建议，您可通过<a href="mailto:cbsg_privacy@cbsg.canon.com.cn">点击此处</a>与我们联系。请监护人理解，为了保障儿童个人信息安全，在响应监护人反馈的问题前，我们可能需要监护人提供相关材料证明其监护人身份。我们将在收到反馈并验证监护人身份后的十五个工作日内回复监护人的相关请求。</div>
        <div class="paragraph">&nbsp;</div>
      </div>
      <div></div>
    </section>
    <learnmore :option="learn_option">
      <template slot="line_one">了解更多佳能产品及解决方案</template>
      <template slot="learn_more_button">联络我们</template>
    </learnmore>
  </section>
</template>
<script>
import bannertitle from './bannertitle'
import learnmore from '../LearnMore'
export default {
  name: 'CompanyProfile',
  components: { bannertitle, learnmore },
  props: [
    'belongTo'
  ],
  data () {
    return {
      learn_option: {
        backgroundColor: '#505050',
        fontColor: 'white'
      }
    }
  },
  methods: {
  },
  created () {
  },
  mounted () {
  }
}
</script>
<style scoped lang="scss" src='../../assets/FFP/css/Article.scss'>
</style>
<style scoped lang="scss">
$p-size: 32px;
$p-size-small: 24px;
$span-size: 20px;
$span-size-small: 16px;
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

a {
  text-decoration: none;
}

.banner_image {
  width: 100%;
}
.width_100 {
  width: 100%;
}

.width_50 {
  width: 50%;
}

.background_color_gray {
  background-color: #ebebeb;
}
.background_color_white {
  background-color: #ffffff;
}
.about_company {
}
.about_company .article_contioner {
  width: 100%;
  padding: 100px 300px;
}

.about_company .article_image {
  background: linear-gradient(
    #ffffff 0%,
    #ffffff 29%,
    #ffffff 30%,
    #eceded 30%,
    #ebebeb 100%
  );
}
.about_company .article_image img {
  width: 50%;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.about_company .article_contioner .article_title {
  font-size: 36px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 50px;
}
.about_company .article_contioner .article_text {
  font-size: 24px;
  font-weight: 600;
  color: #414141;
}
.about_company .article_contioner .article_text p {
  margin-bottom: 20px;
}

@media (min-width: 544px) and (max-width: 1200px) {
  .about_company .article_contioner {
    padding: 80px 100px;
  }
  .about_company .article_image img {
    width: 70%;
  }
}

@media (max-width: 544px) {
  .about_company .article_contioner {
    padding: 20px 40px;
  }
  .about_company .article_image img {
    width: 70%;
  }
  .about_company .article_contioner .article_title {
    font-size: 24px;
    margin-bottom: 10px;
  }
  .about_company .article_contioner .article_text {
    font-size: 18px;
  }
}

.milestone_title {
  margin: 100px;
  font-size: 36px;
  font-weight: 600;
  text-align: center;
}

@media (max-width: 544px) {
  .milestone_title {
    margin: 40px;
    font-size: 24px;
  }
}

.milestone {
  position: relative;
  width: 75%;
  left: 50%;
  transform: translateX(-50%);
}

@media (max-width: 1200px) {
  .milestone {
    width: 90%;
  }
}

.milestone_line {
  position: absolute;
  left: 9px;
  height: 100%;
  border-left: 2px solid #f2524e;
}
.milestone_item {
  position: relative;
  padding-top: 20px;
}

.milestone_time {
  font-size: 36px;
  color: #f2524e;
  position: relative;
  top: 0px;
  left: -5px;
  background-color: #ffffff;
  margin: 10px 10px 10px 0;
}

.milestone_circle {
  height: 20px;
  width: 20px;
  border: 2px solid #f2524e;
  border-radius: 50%;
  position: absolute;
  top: 30%;
  background-color: #ffffff;
}
.milestone_image img {
  height: 200px;
}

@media (min-width: 544px) and (max-width: 768px) {
  .milestone_image img {
    height: 150px;
  }
}

@media (max-width: 544px) {
  .milestone_image img {
    height: 80px;
  }
}
.milestone_article {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 2px solid #ebebeb;
  margin: 0 100px;
}

@media (min-width: 544px) and (max-width: 1200px) {
  .milestone_article {
    margin: 0 50px;
  }
}

@media (max-width: 544px) {
  .milestone_article {
    margin: 0 30px;
  }
}

.milestone_article .milestone_text {
  font-size: 24px;
  margin-left: 50px;
}

@media (min-width: 544px) and (max-width: 768px) {
  .milestone_article .milestone_text {
    font-size: 18px;
    margin-left: 20px;
  }
}
@media (max-width: 544px) {
  .milestone_article .milestone_text {
    font-size: 14px;
    margin-left: 10px;
  }
}
.font_size_32px {
  font-size: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/Article/PrivacyPolicy.vue